import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import { ActionIconCheckmark, constants } from '@klarna/bubble-ui';
import { MOET_CONSTANTS } from 'moet-core';

const { STEP_STATUS } = MOET_CONSTANTS;

const styles = {
  spacer: {
    borderWidth: 5,
    borderStyle: 'solid',
    borderColor: constants.Colors.WHITE,
  },
  circle: {
    borderRadius: 25,
    width: 46,
    height: 46,
    padding: 10,
    borderSize: 1,
    borderStyle: 'solid',
  },
};

const getIcon = status => {
  if (status === STEP_STATUS.APPROVED) {
    return <ActionIconCheckmark colorToken="colors/text/inverse" />;
  }

  return null;
};

const getBackgroundColor = status => {
  if (status === STEP_STATUS.APPROVED) {
    return constants.Colors.GREEN;
  }

  return null;
};

const getBorderColor = status => {
  return getBackgroundColor(status) || constants.Colors.GRAY;
};

const StatusIcon = ({ status }) => {
  return (
    <div style={styles.spacer}>
      <div
        style={{
          ...styles.circle,
          backgroundColor: getBackgroundColor(status) || constants.Colors.WHITE,
          borderColor: getBorderColor(status),
        }}
      >
        {getIcon(status)}
      </div>
    </div>
  );
};

StatusIcon.propTypes = {
  status: PropTypes.string,
};

export default StatusIcon;
